import "core-js";
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/styles/scss/custom-bootstrap.scss";
import "./agGridEnterprise";
import "./index.css";
import {
  AgChartsEnterpriseModule,
  AllEnterpriseModule as AllChartsEnterpriseModule,
  AnnotationsModule,
  ModuleRegistry as AgChartsModuleRegistry,
} from "ag-charts-enterprise";
import {
  AllEnterpriseModule,
  IntegratedChartsModule,
  ModuleRegistry,
} from "ag-grid-enterprise";

ModuleRegistry.registerModules([
  AllEnterpriseModule,
  IntegratedChartsModule.with(AgChartsEnterpriseModule),
]);

// Standalone AG Charts (ag-charts-react) has its own ModuleRegistry separate
// from AG Grid's. AgChartsEnterpriseModule is the integrated-charts bundle —
// the standalone path needs AllEnterpriseModule for series + features. v13.2.1
// has a bug where AnnotationsModule's toolbar fires `r.toJson is not a function`
// on every cartesian chart's post-render flush, so exclude it until upstream fixes.
AgChartsModuleRegistry.registerModules(
  AllChartsEnterpriseModule.filter((m) => m !== AnnotationsModule)
);

import * as serviceWorker from "./serviceWorker";

import App from "./App";
import { Provider } from "react-redux";
import React from "react";
import { createRoot } from "react-dom/client";
import { Spinner } from "./utils/Spinner/spinner";
import _ from "lodash";
import $ from "jquery";
import store from "./redux/store/index";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 5 * 60 * 1000, retry: 1 } },
});

window._ = _;
window.jQuery = $;
window.$ = $;

// Global error handler to surface errors on blank-page failures
window.addEventListener('error', (event) => {
  const el = document.getElementById('root');
  if (el && !el.hasChildNodes()) {
    el.innerHTML = `<div style="padding:2rem;font-family:monospace;color:#c00"><h2>Startup Error</h2><pre>${event.message}\n${event.filename}:${event.lineno}</pre></div>`;
  }
});
window.addEventListener('unhandledrejection', (event) => {
  const el = document.getElementById('root');
  if (el && !el.hasChildNodes()) {
    el.innerHTML = `<div style="padding:2rem;font-family:monospace;color:#c00"><h2>Unhandled Promise Rejection</h2><pre>${event.reason}</pre></div>`;
  }
});

try {
  const root = createRoot(document.getElementById("root"));
  root.render(
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <App />
        <Spinner />
      </Provider>
    </QueryClientProvider>
  );
} catch (err) {
  const el = document.getElementById("root");
  if (el) {
    el.innerHTML = `<div style="padding:2rem;font-family:monospace;color:#c00"><h2>Render Error</h2><pre>${err.stack || err.message || err}</pre></div>`;
  }
}

serviceWorker.unregister();
